import { Container, Logo } from "./styles";
import capivara from "../../../../assets/images/capivara.png";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LoginService } from "../../services";
import { Page } from "../../../../components/page-base";
import { useAuthContext } from "../../../../contexts/auth-contex";
import { saveToLocalStorage } from "@/modules/consult/utils/utils";
import { TUser } from "@/modules/users/models";
import { TVerifyEmail } from "../../models";

export const EmailConfirm: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const { loginEmailConfirmation } = useAuthContext();

  const [loading, setLoading] = useState<boolean>(true);
  const [message, setMessage] = useState<string>("");
  const [success, setSuccess] = useState<boolean>(true);
  const [emailConfirmation, setEmailConfirmation] = useState<TVerifyEmail | null>(null);
  const [user, setUser] = useState<TUser | null>(null);


  useEffect(() => {
    const verifyEmailToken = async () => {
      if (!token) {
        setMessage("Falha ao fazer a verificação de cadastro");
        setLoading(false);
        return;
      }
      const res = await LoginService.verifyEmail(token);

      if (res && res.user) {
        setUser(res.user)
        setEmailConfirmation(res);
        setSuccess(res.success);
        setMessage(res.message);
      } else {
        setMessage(res.message)
      }
      setLoading(false);
    };

    verifyEmailToken();
  }, [token]);

  const ButtonTemplate = () => {
    if (loading) return <></>
    if (success && user) {
      return user.role === 'owner' ?
        <Page.Button type="button" label="Ir para pagamento" />
      : <Page.Button type="button" label="Ir para consulta" />
      }
  }

  return (
    <Container>
      <Logo>
        <img src={capivara} alt="Logo" />
      </Logo>
      {loading ? (
        <span className="lbl">Aguarde, verificando token...</span>
      ) : (
        <span className="lbl">{message}</span>
      )}
      <div
        className="btns"
        onClick={async () => {
          if (success) {
            await loginEmailConfirmation(emailConfirmation);
            setTimeout(() => {
              if (user && user.role === 'owner') {
                saveToLocalStorage("firstOwnerLogin", true)
                navigate("/credits");
              } else {
                navigate("/home")
              }
            }, 1500);
          } else {
            window.open("https://wa.me/+5508005913709", "_blank");
          }
        }}
      >
        <ButtonTemplate />
      </div>
    </Container>
  );
};
